import { userRoleItems } from "../../../utils/enum";
import { convertPermission, decodeJWT } from "./../../../utils";

export const setPermissionsAction = (accessToken) => {
  const token = decodeJWT(accessToken);
  let permissions = token?.permissions;
  if (token?.role !== userRoleItems[0])
    permissions = permissions?.replaceAll("0", "1");

  return async (dispatch) => {
    await dispatch({
      type: "SET_PERMISSIONS",
      payload: {
        ...convertPermission(permissions),
      },
    });
  };
};

export const clearPermissionsAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_PERMISSIONS" });
  };
};
